import { userAtom } from '@states/Atoms';
import React, { useState } from 'react';
import { useRecoilValue } from 'recoil';
import styled from 'styled-components';
import { FormDataType } from './FormDataType';
import ShowForm from './ShowForm';
import SubmitForm from './SubmitFormClose';

type Props = {
    memoId: string;
    afterSbumit: any;
};
type InformationType = {
    lastSubmitTime: number;
};

const information: InformationType = {
    lastSubmitTime: 0
};
const formData: FormDataType = {
    id: '',
    statusKbn: '1',
    updateUser: '',
    timestamp: 0
};


const WarningMessageFormClose = (props: Props) => {
    const { memoId, afterSbumit } = props;
    const userInformation: any = useRecoilValue(userAtom.infomationState);
    const [ submitFlag, setSubmitFlag ] = useState(false);

    const onSubmitStart = (data: FormDataType) => {
        const lastSubmitTime = new Date().getTime();
        if (information.lastSubmitTime !== lastSubmitTime) {
            formData.statusKbn = data.statusKbn;
            formData.timestamp = new Date().getTime();
            information.lastSubmitTime = lastSubmitTime;
            setSubmitFlag(true);
        }
    };
    const onSubmitComplete = () => {
        setSubmitFlag(false);
        afterSbumit();
    };
    formData.id = memoId;
    formData.updateUser = userInformation.name;

    return (
        <FormWrapperWithStyled>
            {!submitFlag ?
                <ShowForm onSubmitStart={onSubmitStart} />
            :
                <SubmitForm onSubmitComplete={onSubmitComplete} formData={formData} />
            }
        </FormWrapperWithStyled>
    );
};

const FormWrapperWithStyled = styled.div`
    margin: 0;
`

export default WarningMessageFormClose;